module.exports = __webpack_public_path__ + "img/iphone-install-2.23ef82ce.jpg";